// extracted by mini-css-extract-plugin
export default {"cls1":"gREGZx8rLUTUPDsCTpjA","cls2":"bwIsMGSJ5yvMKF6w6ryP gREGZx8rLUTUPDsCTpjA"};